const NOTIFICATION_CONSTANTS = {
    TYPES:[
        {label: 'Info', value: 'Info'},
        {label: 'Warning', value: 'Warning'},
        {label: 'Error', value: 'Error'},
        {label: 'Maintenance', value: 'Maintenance'}
],
    TYPE_MAINTENANCE: "Maintenance",
    TYPE_ERROR : "Error",
    TYPE_WARNING : "Warning"
}

export default NOTIFICATION_CONSTANTS;